import { getFetch, postFetchWithToken } from "../../utils/fetch";

async function getJens(term) {
  const data = await getFetch(`/ReportWeb/Jens?term=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeJens(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'عنوان کالا الزامی است!',
    }
  }

  const res = await postFetchWithToken("/Jens/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'کالا با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }

}
export { getJens, storeJens };
